/** The current value of a disposition blocking alert. */
class DispositionBlockingAlertValue {
  /** The unique identifier for the error. */
  readonly id: string;
  /** A flag indicating if this error is currently active and should prevent dispositioning. */
  readonly value: boolean;

  constructor(id: string, value: boolean) {
    this.id = id;
    this.value = value;
  }
}

export default DispositionBlockingAlertValue;
